import * as actions_analytics from 'actions/analytics-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect } from 'react';
import { Ibox } from 'enspire-manager-framework';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function ServiceRequestsCard({ startdate, enddate }) {
        
    const params = useParams();
    const dispatch = useDispatch();

    const analytics = useSelector((store) => store.analytics);
    const service = analytics?.analytics_service_requests;
    
    useEffect(() => {
        if (startdate && enddate) {
            dispatch(actions_analytics.getServiceRequestAnalytics(params.handle, params.appId, startdate, enddate));
        }
    }, [startdate, enddate, params.handle]);
 
    return (
        <div className="ibox animated fadeInRight animation-delay-2">
            <Ibox
                className=""
                title={ <h1 className="main-heading heading-service-request dashboard align-self-start mx-2">Service Requests</h1> }
				show_spinner={ analytics.analytics_service_requests_pending }
            >
                <div className="px-2">
                    <h1 className="no-margins">{ toolbox.formatNumber(service?.totalCost ?? 0, 2, true) }</h1>
                    {/* <div className="stat-percent font-bold text-success">20% <i className="fa fa-level-up"></i></div> */}
                    <small>Total Service</small>

                    <hr />

                    <div className="row">
                        <div className="col-4">
                            <small className="stats-label">#&nbsp;Requests</small>
                            <h4>{ service?.count }</h4>
                        </div>
                        <div className="col-4">
                            <small className="stats-label">Incomplete</small>
                            <h4>{ service?.incomplete }</h4>
                        </div>
                        <div className="col-4 text-right">
                            <small className="stats-label">$&nbsp;Completed</small>
                            <h4>{ toolbox.formatPercentage((service?.totalCompleted ?? 0) / (service?.totalCost ?? 1), 2) }</h4>
                        </div>
                    </div>
                </div>
            </Ibox>
        </div>
    );
}